// Page wrapper para Contratos de Terceros (Req 1, 2026-05-13).
import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import ListContracts from "../../components/Contracts/ListContracts";
import AdminLayout from "../../layouts/AdminLayout";

export default function ListContractsPage() {
  const { user } = useContext(AuthContext);
  const nombreUsuario = user?.nombre || "Usuario";

  return (
    <AdminLayout nombreUsuario={nombreUsuario}>
      <div className="mt-8 px-4 md:px-8">
        <ListContracts />
      </div>
    </AdminLayout>
  );
}
